import Breadcrumbs from 'components/Breadcrumbs';
import { Button } from 'components/buttons/Button/Button';
import 'components/Banner/styles.scss';

const Banner = ({ title, image, buttonText, buttonType = "learn-more" }) => {
    return (
        <div>
            <div className="primary-section-wrapper">
                <div className="primary-section">
                    <div className="left-side">
                        <Breadcrumbs />
                        <h2>{title}</h2>
                    </div>
                    <div className="button-wrapper">
                        <Button type={buttonType}>{buttonText}</Button>
                        <div className="smooth-corner1"></div>
                        <div className="smooth-corner2"></div>
                    </div>
                </div>
                <img src={image} alt={title} />
            </div>
            {buttonType.includes('find') && (
                <Button type="find-mobile" className="banner-bottom">
                    {buttonText}
                </Button>
            )}
            {buttonType.includes('banner') && <Button className="banner-bottom">{buttonText}</Button>}
        </div>
    );
};
export default Banner;
